import { createSelector } from 'reselect'
import { NAV_LINKS } from 'utils/Client/navLinks'
import { OE_PROSPECT, OE_CLIENT }  from 'utils/Client/userTypes'

const getUserTypeState = state => state.user.user

export const isProspectUser = createSelector(
  getUserTypeState,
  user =>  user.onlineExperienceType === OE_PROSPECT
)

export const getNavLinks = (prospectExperience) => {
  if (prospectExperience) {
    return NAV_LINKS.filter(link => link === 'documents')
  }

  return NAV_LINKS
}

export const isClientUser = createSelector(
  getUserTypeState,
  user =>  user.onlineExperienceType === OE_CLIENT
)

export default {
  getNavLinks,
  isClientUser,
  isProspectUser,
}



// WEBPACK FOOTER //
// ./src/selectors/onlineExperience/onlineExperienceTypes.js